import { DataPoint, DataPointResponse } from '@/interfaces';
import { format } from 'date-fns';

// Define a generic data interface that covers all three possible types

// Función para convertir segundos a formato 'm min s seg'
export const formatSeconds = (seconds: number) => {
	if (seconds >= 3600) {
		const hours = Math.floor(seconds / 3600);
		const minutes = Math.floor((seconds % 3600) / 60);
		return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
	}

	if (seconds >= 60) {
		const minutes = Math.floor(seconds / 60);
		return `${minutes}m`;
	}

	return `${seconds}s`;
};

export const fillTimelineChart = (
	data: DataPointResponse[]
	// dateFilter: DateFilterValue | undefined
): DataPoint[] => {
	return data.map(({ period, total_data, totalSeg }) => {
		const datePart = period.split('T')[0].replace('-', '/'); // this is to return this format YYYY/MM/DD which is the format that date-fns is better at parsing

		const label: string = format(datePart, 'MMM dd');

		// Prefer totalSeg (GA average time on page) when available; otherwise fall back to total_data
		let value: number;
		if (totalSeg !== undefined && totalSeg !== null) {
			// totalSeg sometimes comes as a string with the word "min" appended. We extract the numeric part.
			const numericMinutes =
				typeof totalSeg === 'string'
					? parseFloat(totalSeg.replace(/[^0-9.-]+/g, ''))
					: totalSeg;
			// Convert minutes to seconds for consistent usage across the chart.
			value = isNaN(numericMinutes) ? 0 : numericMinutes * 60;
		} else {
			value = total_data ?? 0;
		}

		return {
			date: period,
			value,
			label,
		};
	});
};
